var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconArrowRight = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--arrow-right",
  width: 15,
  height: 15,
  viewBox: "0 0 451.846 451.847",
  ref: svgRef
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Arrow right icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M345.441 248.292L151.154 442.573c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744L278.318 225.92 106.409 54.017c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.287 194.284c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconArrowRight.ef395894.svg";
export { ForwardRef as ReactComponent };